import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class OfficeDynamicPropertyValidator extends CustomCommonValidator implements ValidatorConstraintInterface {
	validate(dynamicProperties: any, validationArguments: ValidationArguments) {
		let properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
		let result: boolean = true;
		const validator = this.getValidator();
		this.message = '';
		if (properties.find(p => p == 'openingHour') != null) {
			let openingHour: any = dynamicProperties['openingHour'] as any;
			if (!validator.isNotEmpty(openingHour)) {
				this.message = this.message.concat('Opening Hour is required<br />');
				result = false;
			}
		}
		if (properties.find(p => p == 'closingHour') != null) {
			let closingHour: any = dynamicProperties['closingHour'] as any;
			if (!validator.isNotEmpty(closingHour)) {
				this.message = this.message.concat('Closing Hour is required<br />');
				result = false;
			}
		}
		return result;
	}

	defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
		return this.message;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/officeDynamicPropertyValidator.ts